import React from "react";
import { HiOutlineAcademicCap } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneClasses } from "../../../lib/sysNavigation/SysNavigation";

type ClassRow = {
  class_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<ClassRow>
    type={_TYPES_.CLASSES}
    title="Classes"
    subtitle="Classes and workshops listed on the public site."
    icon={<HiOutlineAcademicCap className="h-5 w-5" />}
    addRoute="/data/class/add"
    editRoute="/data/class/edit"
    pushOne={pushOneClasses}
    dataKey="classes"
    countKey="classesCount"
    idField="class_id"
  />
);

export default Overview;
